module.exports = __webpack_public_path__ + "img/feature_super.3f38a43d.png";